/* eslint-disable no-magic-numbers */
export const capitaliseFirstLetter = (string: string) =>
  string.charAt(0).toUpperCase() + string.slice(1);

export const toSentenceCase = (text: string, separator = '_') => {
  return capitaliseFirstLetter(text.replaceAll(separator, ' ').toLowerCase());
};

export const startsWithVowel = (text: string): boolean => {
  return /^[aeiou]/i.test(text);
};

export const objectValuesToString = (
  object: Record<string, string>,
  separator = ', ',
) => {
  return Object.values(object)
    .filter((value) => value?.trim())
    .join(separator);
};

export const camelCaseToWords = (string: string) => {
  return string.replace(/([A-Z])/g, ' $1');
};

export const dataURItoFile = (dataURI: string): File => {
  // Split the Data URI to get the MIME type and Base64 content
  const [metadata, base64String] = dataURI.split(',');
  const mimeTypeMatch = metadata.match(/data:([^;]+);/);
  const mimeType = mimeTypeMatch ? mimeTypeMatch[1] : 'application/pdf';
  const nameMatch = dataURI.match(/name=([^;]+)/);
  const name = nameMatch ? nameMatch[1] : 'document';

  // Decode the Base64 string and handle binary data
  const binaryString = atob(base64String);
  const bytes = new Uint8Array(binaryString.length);
  // eslint-disable-next-line no-loops/no-loops
  for (let index = 0; index < binaryString.length; index++) {
    // eslint-disable-next-line unicorn/prefer-code-point
    bytes[index] = binaryString.charCodeAt(index);
  }

  // Create a Blob first to ensure data integrity
  const blob = new Blob([bytes], { type: mimeType });

  // Create a File object from the Blob
  return new File([blob], name, { type: mimeType });
};

export const appendSymbol = (
  value: string | undefined,
  symbol: string,
  fallback?: string,
) => {
  if (!value) {
    return fallback ?? '';
  }

  const trimmedValue = value.trim();

  if (trimmedValue.endsWith(symbol)) {
    return trimmedValue;
  }

  return `${trimmedValue}${symbol}`;
};

export const camelToSnake = (camelString: string) =>
  camelString.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
